import type { MatrixClient } from "matrix-js-sdk";
import { Text, Button } from "../../theme/primitives";
import { useConversations } from "./useConversations";
import { ConversationRow } from "./ConversationRow";

interface ConversationListProps {
  client: MatrixClient;
  selectedRoomId: string | null;
  onSelect: (roomId: string) => void;
  onNewChat: () => void;
}

export function ConversationList({ client, selectedRoomId, onSelect, onNewChat }: ConversationListProps) {
  const conversations = useConversations(client);

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", background: "var(--color-panel)" }}>
      <header
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "var(--space-md) var(--space-lg)",
          background: "var(--color-header-bg)",
          color: "var(--color-header-text)",
          borderBottom: "1px solid var(--color-header-bg)",
        }}
      >
        <Text weight="bold" size="lg" style={{ color: "var(--color-header-text)" }}>
          Chats
        </Text>
        <Button variant="primary" onClick={onNewChat} style={{ padding: "var(--space-xs) var(--space-md)" }}>
          + New chat
        </Button>
      </header>

      <div style={{ flex: 1, overflowY: "auto" }}>
        {conversations.length === 0 ? (
          <div style={{ padding: "var(--space-xl)", textAlign: "center" }}>
            <Text muted>No conversations yet.</Text>
            <br />
            <Text muted size="sm">
              Tap “New chat” to start messaging someone.
            </Text>
          </div>
        ) : (
          conversations.map((c) => (
            <ConversationRow
              key={c.roomId}
              client={client}
              conversation={c}
              selected={c.roomId === selectedRoomId}
              onSelect={onSelect}
            />
          ))
        )}
      </div>
    </div>
  );
}
